import {
  ACTIVITIES_COMPONENT_TYPES,
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
} from 'global/constants';
import type { GetActivitiesSectionsQuery } from '../lesson-builder.graphql.generated';
import type { InteractiveLessonSectionFragment } from '../lesson-builder.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export type ComponentActivity = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesActivityComponent' }
>;
export type ComponentResponse = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesResponseComponent' }
>;
export type ComponentMultipleChoice = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesMultipleChoiceComponent' }
>;
export type ComponentTable = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesTableComponent' }
>;
export type ComponentVideo = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesVideoComponent' }
>;
export type ComponentImage = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesImageComponent' }
>;
export type ComponentImageSphere = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesImageSphereComponent' }
>;
export type ComponentInfoBox = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesInfoBoxComponent' }
>;
export type ComponentEbook = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesEbookComponent' }
>;
export type ComponentDocument = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesDocumentComponent' }
>;
export type ComponentAudio = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesAudioComponent' }
>;
export type ComponentInteractive = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesInteractiveComponent' }
>;
export type ComponentEbookInteractive = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesInteractiveEbookComponent' }
>;
export type ComponentLink = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesLinkComponent' }
>;
export type ComponentWebTool = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesWebToolComponent' }
>;
export type ComponentGuidedResearch = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesGuidedResearchComponent' }
>;
export type ComponentColumns = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesColumnsComponent' }
>;
export type ComponentSlideshow = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesSlideshowComponent' }
>;
export type ComponentEquationResponse = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesEquationResponseComponent' }
>;
export type ComponentDraw = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesDrawComponent' }
>;
export type ComponentVocabulary = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesVocabularyComponent' }
>;
export type ComponentFillInBlanks = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesFillInBlanksResponseComponent' }
>;
export type ComponentDiscussion = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesDiscussionComponent' }
>;
export type ComponentInteractiveResponseSequence = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesInteractiveResponseComponent' }
>;
export type ComponentInteractiveResponseCategorise = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesCategoriseResponseComponent' }
>;
export type ComponentRiveAnimation = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesRiveAnimationComponent' }
>;
export type ComponentGif = Extract<
  Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
  { __typename: 'ActivitiesGifComponent' }
>;

export type ComponentColumn = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesColumnsComponent' }
  >,
  'columns'
>;
export type ComponentColumnsComponents = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesColumnsComponent' }
  >,
  'columns.components'
>;

export type ActivityComponentProperties =
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesRiveAnimationComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesDiscussionComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesSlideshowComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesImageComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesTableComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesResponseComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesGuidedResearchComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesLinkComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesWebToolComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesColumnsComponent' }
      >,
      'columnProperties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesColumnsComponent' }
      >,
      'columnProperties.style'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesActivityComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesVideoComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesInfoBoxComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesDocumentComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesEbookComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesDrawComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesGifComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesImageSphereComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesMultipleChoiceComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesInteractiveResponseComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesCategoriseResponseComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesVocabularyComponent' }
      >,
      'properties'
    >
  | Pluck<
      Extract<
        Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
        { __typename: 'ActivitiesFillInBlanksResponseComponent' }
      >,
      'properties'
    >;

export type ComponentSubActivity =
  | ComponentResponse
  | ComponentMultipleChoice
  | ComponentEquationResponse
  | ComponentFillInBlanks
  | ComponentDraw
  | ComponentTable
  | ComponentDiscussion
  | ComponentInteractiveResponseSequence
  | ComponentInteractiveResponseCategorise;

export type ComponentStimulusType = Pluck<
  InteractiveLessonSectionFragment,
  'components'
> & {
  properties?: { stimulusId?: number | null };
};

export const COLUMN_COMPONENT_TYPES = ACTIVITIES_COMPONENT_TYPES.filter(
  c => ![ACTIVITIES_COMPONENT_TYPE_COLUMNS].includes(c)
);
